import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgOverlay',
})
export default class CmgOverlay extends Vue {}
